import React, { useRef, useEffect, useContext } from 'react'
import * as schemas from 'utils/schema.js'
import { navigate } from 'gatsby'

import useZdassetsScript from 'hooks/useZdassetsScript'
import Layout from 'layouts/Layout'
import Instagram from 'components/home/Instagram'
import Why from 'components/home/Why'
import HomeSection from 'components/home/HomeSection'
import Cymatics from 'components/home/Cymatics'
import ChallengeBanner from 'components/home/ChallengeBanner'
import Offers from 'components/home/Offers'
import StarterBundle from 'components/home/StarterBundle'
import EpodSlideshow from 'components/home/EpodSlideshow'
import EpenSlideshow from 'components/home/EpenSlideshow'
import Portal from 'components/Portal'
import MetaTags from 'components/MetaTags'
import NativeAuthContext from 'components/NativeAuth'

const Home = () => {
  const zendeskScriptContainer = useRef(null)
  const { zdassetsScriptContainer } = useZdassetsScript()
  const { province } = useContext(NativeAuthContext)

  useEffect(() => {
    if (province === 'ON') {
      navigate('/ontario/')
    }

    if (province === 'BC') {
      navigate('/bc/')
    }
  }, [province])

  return (
    <>
      <Portal selector="scripts">
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schemas.home) }} />
      </Portal>
      <Layout hideHeader hidePromo>
        <MetaTags
          title="Vape Pen & E-Cigarette Online Shop 🛒 | Welcome to Vuse"
          description="Shop for our exclusive ecigarettes, liquids and accessories directly online. Get up to 30% off pods and free shipping with our Vuse subscription plan. Previously govype.ca"
        />
        <div
          css={`
            background-color: #14191c;
          `}
        >
          <ChallengeBanner />
          <Cymatics hideHeader />

          <Offers />
          <StarterBundle />

          <HomeSection
            figure="home/offers/multipack.jpg"
            title="GET THE BEST DEAL WITH FLAVOUR BUNDLES"
            description={
              <>
                <p>Mix and match our packs of pods and save up to 23%.</p>
                <p>
                  Add 3 or 5 packs to your cart and insert discount code <strong>3FOR33</strong> or{' '}
                  <strong>5FOR50</strong> at checkout.
                </p>
              </>
            }
            promo={
              <>
                <span>
                  <strong>3 for $33</strong>
                </span>
                <span>
                  <strong>5 for $50</strong>
                </span>
              </>
            }
            cta="Shop now"
            link="/buy-online/vype-epod-vpro-cartridges"
          />
          <HomeSection
            figure="home/offers/subscribe.jpg"
            title="Save up to 30% on recurring pods delivery"
            description={
              <>
                <p>
                  1. Select your flavours and quantity.
                  <br />
                  2. Select the recurring date of your monthly delivery.
                  <br />
                  3. Place your order and you are all set.
                </p>

                <p>Additional discounts for vuse+ members.</p>
              </>
            }
            promo={
              <>
                <span>
                  3-4 packs <strong>save 20%</strong>
                </span>
                <span>
                  5+ packs <strong>save 25%</strong>
                </span>
              </>
            }
            cta="Learn more"
            link="/subscribe"
            isReverse
          />

          {/* <Explore /> */}
          <EpodSlideshow steps={3} />
          <EpenSlideshow steps={2} />
        </div>
        <Why />
        {/* <Newsletter /> */}
        <Instagram />
        <div ref={zendeskScriptContainer} />
        <div ref={zdassetsScriptContainer} />
      </Layout>
    </>
  )
}

export default Home
